import { render, staticRenderFns } from "./RateTypePaymentPolicy.vue?vue&type=template&id=5fdc488f&"
import script from "./RateTypePaymentPolicy.vue?vue&type=script&lang=js&"
export * from "./RateTypePaymentPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fdc488f')) {
      api.createRecord('5fdc488f', component.options)
    } else {
      api.reload('5fdc488f', component.options)
    }
    module.hot.accept("./RateTypePaymentPolicy.vue?vue&type=template&id=5fdc488f&", function () {
      api.rerender('5fdc488f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/RateTypePaymentPolicy.vue"
export default component.exports